export type Direction = 1 | -1;

interface ConditionalTabOptions {
  root?: HTMLElement | Document;
}

const getFocusableElements = (root: HTMLElement | Document): HTMLElement[] => {
  const selector = '[class*="ql-editor"]';

  return Array.from(root.querySelectorAll<HTMLElement>(selector)).filter(
    (el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden")
  );
};

export const moveFocus = (
  direction: Direction,
  options: ConditionalTabOptions = {}
) => {
  const root = options.root ?? document;
  const focusables = getFocusableElements(root);
  const active = document.activeElement as HTMLElement | null;
  const currentIndex = focusables.indexOf(active as HTMLElement);
  if (currentIndex === -1) {
    // If nothing / unknown is focused, just focus first or last
    const target =
      direction === 1 ? focusables[0] : focusables[focusables.length - 1];
    target?.focus();
    return;
  }

  const nextIndex = currentIndex + direction;
  const target = focusables[nextIndex];
  target?.focus();
};
